// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__K_3XC","resendInfoText":"OnGoingPaymentBox_resendInfoText__vAfaV"};